import cruise from './modules/cruise'
import user from './modules/user'
import page from './modules/page'
import booking from './modules/booking'
import review from './modules/review'
import tikTok from "./modules/tikTok";
import questionnaire from './modules/questionnaire';

export default {
  page,
  user,
  cruise,
  booking,
  review,
  tikTok,
  questionnaire
}
